import React from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import { TimerText } from 'components/TimerText'

import { selectLanguage } from 'root-redux/selects/common'

import { useABTest } from 'hooks/useABTest'
import { useActiveCohortIdentifier } from 'hooks/useActiveCohortIdentifier'

import { TEN_MINUTES } from 'modules/purchase/constants'
import { selectDynamicDiscount } from 'modules/purchase/redux/selects/common'

import { DynamicDiscountTheme, Locale } from 'root-constants'

import { StyledPurchaseTimer as S } from './PurchaseTimer.styles'

type TPurchaseTimerProps = {
  timerRef: React.RefObject<HTMLElement>
}

export const PurchaseTimer: React.FC<TPurchaseTimerProps> = ({
  timerRef,
}: TPurchaseTimerProps) => {
  const { t } = useTranslation()
  const dynamicDiscount = useSelector(selectDynamicDiscount)
  const language = useSelector(selectLanguage) as Locale
  const { isHolidayActive } = useABTest()
  const { isDynamicDiscountCohort } = useActiveCohortIdentifier()

  return (
    <S.Container
      theme={
        !isDynamicDiscountCohort
          ? DynamicDiscountTheme.CORAL
          : dynamicDiscount?.theme
      }
      isHolidayActive={isHolidayActive}
    >
      <S.Text locale={language} isHolidayActive={isHolidayActive}>
        {isHolidayActive ? (
          <Trans i18nKey="purchase7.christmasTimer" />
        ) : (
          <Trans i18nKey="purchase7.duplicateTimer" />
        )}{' '}
        <strong ref={timerRef}>
          <TimerText timerRef={timerRef} defaultValue={TEN_MINUTES.AS_STRING} />
        </strong>{' '}
        {t('purchase7.min')}
      </S.Text>
    </S.Container>
  )
}
